// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__u67db","active":"Menu_active__aFrRE"};